export default __webpack_public_path__ + "static/media/Scenery01.8e98cb6a.jpg";